<onsip-loading-container [deferCond]="isDataObtained$">
  @if(organization$ | async) { @if ((contactPanel$ | async) === 'view') {
  <onsip-contact-view
    [organization]="(organization$ | async)!"
    (editPanel)="togglePanel('edit')"
  ></onsip-contact-view>
  } @else if ((contactPanel$ | async) === 'edit') {
  <onsip-contact-edit
    [organization]="(organization$ | async)!"
    (editPanel)="togglePanel('view')"
  ></onsip-contact-edit>
  } }
</onsip-loading-container>
